export function isValidExpirationDate(expirationDate: string) {
  const month = Number(expirationDate.split("/")[0]);
  const year = Number(expirationDate.split("/")[1]);

  const currentMonth = Number(new Date().getMonth()) + 1;
  const currentYear = Number(new Date().getFullYear());

  if (month > 12 || month === 0) {
    return false;
  }

  if (year < currentYear) {
    return false;
  }

  if (year === currentYear) {
    if (month <= currentMonth) {
      return false;
    }
  }

  return true;
}
